var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pt-9",attrs:{"justify-center":"","fill-height":""}},[(!_vm.DayShift)?_c('mbs-page-spinner'):_c('mbs-epson-display-temp1',{attrs:{"show":true,"loading":_vm.inputLoading,"print_request":_vm.DAY_SHIFT_PRINT_REQUEST}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }